import EditAction from './Actions/EditAction';
import DeleteAction from './Actions/DeleteAction';

const Actions = (actions: string[], type: string, id: number) => {  
  return (
    actions.map((action) => {
      switch (action) {
        case 'edit':
          return <EditAction type={type} id={id} key={`edit-${type}-${id}`} />;
        case 'delete':
          return <DeleteAction type={type} id={id} key={`delete-${type}-${id}`} />;
        default:
          return null;
      }
    })
  );
}

export default Actions;
